import { useEffect, useRef } from 'react';
import type { FieldErrors } from 'react-hook-form/dist/types/errors';

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const useScrollToError = <T extends unknown>({
    errors,
    submitCount = 0,
}: {
    // @ts-expect-error valid
    errors: FieldErrors<T>;
    submitCount: number;
}) => {
    const submitCountPrevious = useRef(submitCount);

    useEffect(() => {
        const scrollToError = () => {
            if (submitCount !== submitCountPrevious.current) {
                submitCountPrevious.current = submitCount;
                const firstErrorKey = Object.keys(errors).find(
                    (key) => errors[key as keyof typeof errors],
                );

                if (firstErrorKey) {
                    const element = document.querySelector(
                        `input[name="${firstErrorKey}"]`,
                    ) as HTMLInputElement;

                    if (element?.focus && element?.offsetParent) {
                        element.focus();
                    } else if (element?.parentElement) {
                        element.parentElement.scrollIntoView({
                            block: 'center',
                        });
                    } else if (element) {
                        element.scrollIntoView();
                    } else {
                        const node = document.querySelector(`.MuiFormHelperText-root.Mui-error`);

                        if (node) {
                            node.scrollIntoView();
                        }
                    }
                }
            }
        };

        scrollToError();
    }, [errors, submitCount]);
};
